// extracted by mini-css-extract-plugin
module.exports = {"cover":"Landing_cover__2bdj2","wrap":"Landing_wrap__2pAj_","button":"Landing_button__2jaAz","ring":"Landing_ring__29NGe"};